import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const submitContact = async (payload) => {
  const { data } = await apiClient.post("/contact", payload);
  return data;
};

export const ping = async () => {
  const { data } = await apiClient.get("/");
  return data;
};
